module.exports = __webpack_public_path__ + "img/bn_04.b680e98f.jpg";